<script setup>
import { nextTick, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { useStore } from "@Stores/requiredSettings";
import Confetti from "@Components/Animation/Confetti.vue";
import AppLink from "@Components/AppLink.vue";
import Modal from "./Modal.vue";
import { PrimaryButton } from "@Components/Button";

const route = useRoute();
const store = useStore();
const { t: __ } = useI18n();

const modal = ref();

const toggleModal = () => {
    if (route.name !== "settings") {
        nextTick(() => {
            if (store.hasMissingRequiredSettings) {
                modal.value.show();
            } else {
                modal.value.hide();
            }
        });
    } else {
        nextTick(() => {
            modal.value.hide();
        });
    }
};

watch(
    () => store.hasMissingRequiredSettings,
    () => {
        toggleModal();
    },
    { immediate: true }
);

watch(
    () => route.name,
    () => {
        toggleModal();
    }
);
</script>

<template>
    <Modal ref="modal" :dismissible="false">
        <div class="px-4 py-6 lg:px-8 sm:px-6">
            <div class="mx-auto flex justify-center items-center rounded-full">
                <Confetti class="w-28 h-28" />
            </div>

            <h3 class="mt-3 text-3xl font-semibold leading-tight text-center text-gray-900 dark:text-white">
                {{ __("Bienvenue sur otomatic.ai") }}
            </h3>

            <div class="mt-6 text-base text-center text-gray-600 dark:text-gray-400">{{ __("Configurons ensemble les différents services.") }}</div>

            <div class="flex justify-center items-center mt-6">
                <PrimaryButton :z="1" :as="AppLink" :to="{ name: 'settings' }"> {{ __("C'est parti !") }}</PrimaryButton>
            </div>
        </div>
    </Modal>
</template>
